import { render } from "./SpaTreatmentConfirmation.vue?vue&type=template&id=c58b7dda"
import script from "./SpaTreatmentConfirmation.vue?vue&type=script&lang=js"
export * from "./SpaTreatmentConfirmation.vue?vue&type=script&lang=js"

import "./SpaTreatmentConfirmation.vue?vue&type=style&index=0&id=c58b7dda&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__